<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white" v-if="JSON.stringify(data) != '{}'">
				<div class="paper_edit_title flex">
					<div class="paper_edit_title_l">
						<p class="f20px">{{data.name}}</p>
						<div class="f16px cl_gray mat10">答题用时：{{data.time}}</div>
					</div>
					<div class="cl_red f16px"><span class="f24px">{{data.total_points}}</span> 分</div>
				</div>
				<div class="paper_edit mat30">
					<div class="paper_edit_l">
						<div class="paper_edit_nav f18px cl_dark">
							<div class="paper_edit_nav_list cur" :class="{'on': nav_cur == 1}" @click="navCheck(1)">试卷</div>
							<div class="paper_edit_nav_list cur" :class="{'on': nav_cur == 2}" @click="navCheck(2)">答案与解析</div>
						</div>
						<div class="paper_edit_cont mat20 bs" :style="{maxHeight:height}">
							<pdf v-for="i in numPages" :key="i" :src="src" :page="i" @page-loaded="pageLoaded($event)"></pdf>
						</div>
					</div>
					<div class="paper_edit_r" ref="paper_height">
						<div class="tc f20px">答题卡</div>
						<div class="cl_gray tc">共计{{data.num}}小题，总计{{data.fraction_all}}分</div>
						<div class="paper_edit_card mat20">
							<div class="paper_card_list" v-for="(item,index) in data.card_json_arr" :key="index">
								<div class="found_list_title flex f16px cl_violet radius8">
									<div class="found_list_title_l">{{item.number}}、{{item.type}}</div>
									<div>共{{item.topic.length}}题，{{item.fraction_all}}分</div>
								</div>
								<div class="found_list_cont mat20">
									<div class="found_list_item flex radius8" v-for="(second,secondIndex) in item.topic" :key="secondIndex">
										<div class="found_list_item_l flex">
											<div class="found_list_item_index">{{second.id}}</div>
											<div class="found_list_item_cont flex" v-if="item.type == '选择题'">
												<div class="found_list_item_check_cont flex cl_gray tc">
													<div class="radius found_list_item_check" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
													:class="[{'false': second.is_right == 0 && third.on},{'true': second.is_right == 1 && third.on}]">{{third.name}}</div>
												</div>
											</div>
											<div class="found_list_item_cont flex" v-if="item.type == '判断题'">
												<div class="found_list_item_judge cl_gray tc" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
												:class="[{'false': second.is_right == 0 && third.name == second.reply}, {'true':  second.is_right == 1 && third.name == second.reply}]">{{third.name}}</div>
											</div>
											<div class="found_list_item_cont" v-if="['选择题','判断题'].indexOf(item.type) < 0">
												<p class="cl_dark">得<span class="cl_gray">{{second.mark}}</span>分<span class="cl_gray">（满分{{second.fraction}}分）</span></p>
											</div>
										</div>
										<div class="found_list_item_r">
											<div v-if="second.is_right == 0 && item.type == '选择题'" class="cl_gray f12px">正确答案：
												<span v-for="(third,thirdIndex) in second.arr" :key="thirdIndex" v-if="third.on">{{third.name}}</span>
											</div>
											<div v-if="second.is_right == 0 && item.type == '判断题'" class="cl_gray f12px">正确答案：{{second.answer}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	import pdf from 'vue-pdf'
	
	export default {
		name: 'task_school_paper',
		components: {
			studentNav,
			pdf,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				id: "",
				data: {},
				nav_cur: 2,
				loading: true,
				src: '',
				numPages: undefined, // 总页数
				curPageNum: 0, //当前页
				height: "600px",
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getTask();
			}
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getTask () {
				this.$get("/api/student/get_my_homework_done_dtl",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					let fraction_all = 0;
					let num = 0;
					for (let i = 0; i < res.data.data.card_json_arr.length; i++) {
						fraction_all += res.data.data.card_json_arr[i].fraction_all;
						res.data.data.fraction_all = fraction_all;
						num += res.data.data.card_json_arr[i].topic.length;
						res.data.data.num = num;
					}
					this.data = res.data.data;
					let that = this;
					that.src = pdf.createLoadingTask(that.data.answ_file); // url是pdf文件的全路径
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
					setTimeout(() => {
						let height= that.$refs.paper_height.offsetHeight;
						if (height > 600) {
							that.height = height - 60 + "px"
						}
					}, 0);
				});
			},
			navCheck (e) {
				let that = this;
				that.nav_cur = e;
				if (e == 1) {
					that.src = pdf.createLoadingTask(that.data.ques_file);
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
				} else {
					that.src = pdf.createLoadingTask(that.data.answ_file);
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
				}
				that.curPageNum = 0;
			},
			pageLoaded(e) {
				this.curPageNum = e;
				if (this.curPageNum == this.numPages) { //加载完最后一页
					this.loading = false;
				}
			},
		},
	}
</script>

<style>
</style>
